import type { ChangeEvent } from 'react';
import { getFieldValue } from '../../../utils/toolInspection.utils';
import {
  TOOL_INSPECTION_FIELD_ID as IDS,
  IInitialFieldConfig,
  TToolInspectionParsedValue
} from 'constants/toolInspection.constants';

import './InspectionCommentSection.scss';

interface IInspectionCommentSectionProps {
  formFields: Record<number, IInitialFieldConfig>;
  onFieldChange: (id: number, value: TToolInspectionParsedValue) => void;
  isDisabled: boolean;
}

const InspectionCommentSection = ({ formFields, onFieldChange, isDisabled }: IInspectionCommentSectionProps) => {
  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.target.value;
    onFieldChange(IDS.COMMENTS, value);
  };

  return (
    <section className="inspectionCommentSection">
      <p className="inspectionCommentSectionTitle">Comentarios</p>
      <textarea
        className="inspectionCommentField"
        value={getFieldValue<string>(formFields, IDS.COMMENTS) || ''}
        onChange={handleChange}
        placeholder="Escribe tu comentario aquí..."
        disabled={isDisabled}
      />
    </section>
  );
};

export default InspectionCommentSection;
